import { render } from "./ComponentsMapping.vue?vue&type=template&id=26f552a7"
import script from "./ComponentsMapping.vue?vue&type=script&lang=js"
export * from "./ComponentsMapping.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wisdom/Documents/workspace/hoc-element-table/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.72.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__